module.exports = __webpack_public_path__ + "static/media/dra-ifran.8231bcf6.mp3";